import React, { useEffect } from "react";
import { graphql } from "gatsby";
import parse from "html-react-parser";
import { Asset } from "../../../../plugins/gatsby-plugin-atollon";
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const TitleGallery = ({title, items, special}) => {
  useEffect(() => {
    ['.title-gallery__item-1', '.title-gallery__item-2', '.title-gallery__item-3'].forEach(item => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: `.title-gallery__items`,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });

      tl.fromTo(
        `.title-gallery ${item}`,
        {yPercent: 70},
        {yPercent: -70, ease: 'none'}
      );

      tl.fromTo(
        `.title-gallery .title-gallery__item-0 .gatsby-image-wrapper`,
        {transform: 'translate3d(0, -30%, 0)'},
        {transform: 'translate3d(0, 30%, 0)', ease: 'none'},
        0
      );

      tl.fromTo(
        `.title-gallery__items ${item} .gatsby-image-wrapper`,
        {transform: 'translate3d(0, -30%, 0)'},
        {transform: 'translate3d(0, 30%, 0)', ease: 'none'},
        0
      );
    });
  }, []);

  return (
    <section className={`title-gallery${special ? ' special' : ''}`}>
      <div className="title-gallery__inner">
        {title && <h2 data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">{parse(title)}</h2>}
        <div className="title-gallery__items">
          {
            items?.length > 0 && items.map((el, i) => (
              <div key={i} className={`title-gallery__item title-gallery__item-${i}`}>
                <div className="title-gallery__item-inner" data-sal="slide-up"
                     data-sal-duration="1000" data-sal-easing="ease">
                  <div className="title-gallery__item-wrapper">
                    {el.image && !el.video && <Asset asset={el.image}/>}
                    {el.video &&
                      <video className="title-gallery__video" src={el.video} autoPlay loop muted
                             playsInline/>}
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default TitleGallery

export const query = graphql`
fragment TitleGalleryProps on DatoCmsTitleGallery {
  ... on DatoCmsTitleGallery {
    id
    title
    items {
      image {
        ...InternalAssetProps
      }
      video
    }
    special
  }
}
`